import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import DashboardLayout from "../../../examples/LayoutContainers/DashboardLayout";
import { ShimmerPostList } from "react-shimmer-effects";
import { getDrivers } from "../../../actions/driver/driver";
import OperatorListComponent from "../../../components/Definition/Operator/OperatorListComponent";
import { deleteOperator, getOperators } from "../../../actions/operators/operators";
import { deleteEquipment } from "../../../actions/equipments/equipments";
import { deletePurchasor, getPurchasor } from "../../../actions/purchasor/purchasor";
import PurchasorListComponent from "../../../components/Definition/Purchasor/PurchasorListComponent";

export default function PurchasorScreen() {
    const [operators, setOperators] = useState({ data: [], links: {} });
    const [loading, setLoading] = useState(true);
    const [status, setStatusDelete] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();


    useEffect(() => {
        setLoading(true);
        const fetchApi = async () => {
            const params = new URLSearchParams(searchParams);
            try {
                const usersData = await getPurchasor(params.toString());
                setLoading(false);
                setOperators(usersData.status !== "error" ? usersData.message : { data: [], links: {} });
            } catch (error) {
                toast.error('خطا در اتصال به سرور!');
                setLoading(false);
            }
        };

        fetchApi();
    }, [searchParams,status]);

    return (
        <DashboardLayout>
            {loading ? <ShimmerPostList postStyle="STYLE_THREE" col={1} row={3} gap={30} /> : <PurchasorListComponent lists={operators} deleteInvoke={async(id)=>{
                const prompt = window.confirm("آیا میخواهید مشتری حذف شود ؟ با این کار گزارشات وابسته از بین خواهد رفت")
                if(prompt){
                    const response = await deletePurchasor(id);
                    if (response.status === "success") {
                        toast.success("مشتری حذف شد!");
                        window.location.reload();
                        setStatusDelete(true);
                    } else {
                        toast.error("خطا در حذف مشتری!");
                    }
                }
            }} />}
        </DashboardLayout>
    );
}
